import { gql, useApolloClient } from '@apollo/client';
import { useHistory } from 'react-router-dom';
import { getLocalStorage } from 'shared/utils/localStorage';
import { useMemo } from 'react';
import { isAuthenticated, setSession, removeSession } from '../auth';

const LOGIN_MUTATION = gql`
  mutation Login($email: String!, $password: String!, $mfaCode: String) {
    login(email: $email, password: $password, mfaCode: $mfaCode) {
      accessToken
      expiresAt
      refreshToken
      mfa
    }
  }
`;

const DEMO_LOGIN_MUTATION = gql`
  mutation DemoLogin {
    demoLogin {
      accessToken
      expiresAt
      refreshToken
    }
  }
`;

const REQUEST_PASSWORD_MUTATION = gql`
  mutation RequestPasswordReset($email: String!) {
    requestPasswordReset(email: $email)
  }
`;

export default () => {
  const client = useApolloClient();
  const history = useHistory();

  const login = async (email, password, mfaCode, path = '/') => {
    const { data, errors } = await client.mutate({
      mutation: LOGIN_MUTATION,
      variables: { email, password, mfaCode },
    });
    if (errors || !data?.login) {
      throw new Error('Unauthorized');
    }

    if (data.login.mfa) {
      return { mfa: true };
    }

    const { accessToken, expiresAt, refreshToken } = data.login;
    setSession(accessToken, expiresAt, refreshToken);
    history.push(path);
    return null;
  };

  const demoLogin = async () => {
    const { data } = await client.mutate({
      mutation: DEMO_LOGIN_MUTATION,
    });

    if (!data?.demoLogin) {
      throw new Error('Unauthorized');
    }

    const { accessToken, expiresAt, refreshToken } = data.demoLogin;
    setSession(accessToken, expiresAt, refreshToken);
    history.push('/');
  };

  const requestNewPassword = async (email) => client.mutate({
    mutation: REQUEST_PASSWORD_MUTATION,
    variables: { email },
  });

  const logout = () => {
    removeSession();
    client.clearStore();
    history.push('/login');
  };

  const impersonate = (userId) => {
    getLocalStorage().setItem('impersonate', userId);
    client.clearStore();
    history.push('/');
  };

  const stopImpersonation = () => {
    getLocalStorage().removeItem('impersonate');
    client.resetStore();
  };

  const getImpersonatedUser = () => {
    const userId = getLocalStorage().getItem('impersonate');
    return userId;
  };

  return useMemo(() => ({
    login,
    demoLogin,
    requestNewPassword,
    logout,
    isAuthenticated,
    impersonate,
    stopImpersonation,
    getImpersonatedUser,
  }), [client, history]);
};
